import type { Proposal } from '../../types/db';

export const proposals: Proposal[] = [
  {
    id: 'p-mail-bakker',
    agent: 'mail',
    kind: 'mail',
    title: 'Antwoord aan klant Bakker',
    refIds: ['d-bakker-reply'],
    traceId: 'mail-bakker',
    where: 'cloud',
    status: 'wacht',
    urgency: 'nu',
  },
  {
    id: 'p-pr-142',
    agent: 'code',
    kind: 'code',
    title: 'PR #142 goedkeuren',
    refIds: ['pr-142'],
    traceId: 'merge-142',
    where: 'lokaal',
    status: 'wacht',
    urgency: 'vandaag',
  },
  {
    id: 'p-bonnen',
    agent: 'boekhouding',
    kind: 'boekhouding',
    title: '2 bonnen inboeken',
    refIds: ['r-1', 'r-2'],
    traceId: 'bonnen',
    where: 'lokaal',
    status: 'wacht',
    urgency: 'kan-wachten',
  },
];
